<div class="col-span-12">
  <app-card variant="elevated" rootClass="h-full" bodyClass="h-full" contentClass="h-full">
    <div class="flex flex-col gap-4 p-5">
      <h2 class="m-0 text-subheading-large text-headingText">
        {{ 'RM.DASHBOARD.SECTOR_PREFERENCES.TITLE' | translate }}
      </h2>

      @if (loading() && !hasItems()) {
        <div class="grid grid-cols-6 gap-4 h-[260px] items-end">
          @for (_ of [1, 2, 3, 4, 5, 6]; track $index) {
            <p-skeleton width="100%" [height]="($index + 3) * 28 + 'px'" />
          }
        </div>
      } @else if (hasItems()) {
        <div class="h-[320px]">
          <p-chart type="bar" [data]="sectorChartData()" [options]="sectorChartOptions" height="320px" />
        </div>
      } @else {
        <div class="flex min-h-[160px] items-center justify-center text-bodyText">
          {{ 'RM.DASHBOARD.SECTOR_PREFERENCES.EMPTY' | translate }}
        </div>
      }
    </div>
  </app-card>
</div>
